import { PanelbarStructure } from "../isPanelbarDetails.js";
import { Helper } from "../../util/helper.js";
import { FAIcon } from "../faIcon.js";
import { AppHelper } from "../../../appHelper.js";
import { StringKeyDictionary } from "../../../commonInterfaces.js";
import {OpenAddressCoordinates} from "../gmEmbedApi.js";
import React from "react"
export default class AddressDetails extends React.Component<any, any> {
    private translations: StringKeyDictionary<string> = {};
    common = new AppHelper();

    componentDidMount() {
        Helper.getTranslations(["Field.Adresse.adrnr", "Field.Adresse.strasse", "Field.Adresse.adrname", "Field.Adresse.plz", "Field.Adresse.adrname2", "Field.Adresse.ort"])
            .then(result => {
                if (Helper.hasValue(result)) {
                    this.translations = result.Data;
                    this.setState({});
                }
            });
    }


    elementReady = (selector: any) => {
        return new Promise((resolve, _) => {
            const el = document.querySelector(selector);
            if (el) {
                resolve(el);
            }
            new MutationObserver((_mutationRecords, observer) => {
                // Query for elements matching the specified selector
                Array.from(document.querySelectorAll(selector)).forEach((element) => {
                    resolve(element);
                    //Once we have resolved we don't need the observer anymore.
                    observer.disconnect();
                });
            })
                .observe(document.documentElement,
                    {
                        childList: true,
                        subtree: true
                    });
        });
    }

    getGeodata = (data: any) => {
        const canShowError = data.Laengegrad == null ||
            data.Breitegrad == null ||
            data.Laengegrad == 0 &&
            data.Breitegrad == 0;

        const nocoords = this.translations == null ? "" : Helper.getTranslation("WebSMS.Geodata.NoCoorinates");

        const text = canShowError && (data.GeocodeText == "" || data.GeocodeText == null)
            ? nocoords
            : data.GeocodeText;

        const iconName = canShowError ? "map-marker-alt-slash" : "map-marker-check";
        const icon =
            <span style={{ display: "inline-block", paddingRight: "10px" }
            }> <FAIcon name={iconName} /></span >;

        const link = canShowError
            ? <span style={{ fontSize: "small" }}>{text}</span>
            : <a style={{flex: 1, fontSize: "small"}} title={Helper.getTranslation("WebSMS.Geodata.ShowOnMap")} 
                 onClick={() => {
                     OpenAddressCoordinates(data.AdrNr, this.common?.commandManager)
                 }}>{text}</a>;

        return (
            <tr>
                <td>
                    <span>{icon}{link}</span>
                </td>
            </tr>);
    }

    render() {
        const data = this.props.data;

        const geo = data.GeocodeEnabled ? this.getGeodata(data) : null;

        const ort = data.Ort == null ? "" : ", " + data.Ort;
        return (
            <PanelbarStructure label={data.AdrName + ort} keyPropValue={data.AdrNr} iconName={"home"} url={"Address/Edit?id=" + encodeURIComponent(data.AdrNr)}>
                <table className="templateHoverTable">
                    <tbody>
                        <tr>
                            <td>
                                <span>{data.AdrName2}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.Strasse}</span>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <span>{data.Plz} {data.Ort}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.Land}</span>
                            </td>
                        </tr>
                        {geo}
                    </tbody>
                </table>
            </PanelbarStructure>
        );
    }
}